import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { MensagemComponent } from './mensagem/mensagem.component';
import { ModalComponent } from './modal/modal.component';
import { MenuComponent } from './menu/menu.component';
import { HeaderComponent } from './header/header.component';
import { CardComponent } from './card/card.component';
import { FormsModule } from '@angular/forms';
import { ContextMenuComponent } from './context-menu/context-menu.component';
import { VerChecklistComponent } from './checklist/ver-checklist/ver-checklist.component';
import { PaginacaoComponent } from './paginacao/paginacao.component';
import { LoadingComponent } from './loading/loading.component';
import { ToolbarComponent } from './toolbar/toolbar.component';
import { PopupComponent } from './popup/popup/popup.component';
import { PendenciasComponent } from './pendencias/pendencias/pendencias.component';
import { ErrorPopupComponent } from './error-popup/error-popup/error-popup.component';
import { SefazStripeComponent } from './sefaz-stripe/sefaz-stripe/sefaz-stripe.component';


@NgModule({
  declarations: [
    MensagemComponent,
    ModalComponent,
    MenuComponent,
    HeaderComponent,
    CardComponent,
    ContextMenuComponent,
    VerChecklistComponent,
    PaginacaoComponent,
    LoadingComponent,
    ToolbarComponent,
    PopupComponent,
    PendenciasComponent,
    ErrorPopupComponent,
    SefazStripeComponent
  ],
  imports: [
    CommonModule,
    RouterModule,
    FormsModule,
  ],
  exports: [
    MensagemComponent,
    ModalComponent,
    MenuComponent,
    HeaderComponent,
    CardComponent,
    ContextMenuComponent,
    VerChecklistComponent,
    PaginacaoComponent,
    LoadingComponent,
    ToolbarComponent,
    PopupComponent,
    PendenciasComponent,
    ErrorPopupComponent,
    SefazStripeComponent
  ]
})
export class SharedModule { }
